import ReactGA from "react-ga";
import { Analytics, logEvent } from "firebase/analytics";

export enum Category {
    Game = "Game",
    Room = "Room",
    Moderation = "Moderation",
    User = "User",
}

export enum Action {
    //Room
    GameStarted = "Game Started",
    EstimationRoundStarted = "Estimation Round Started",
    EstimationRoundCompleted = "Estimation Round Completed",
    ReEstimateClicked = "Re-estimate Clicked",
    RoomCreated = "Room Created",
    RoomJoined = "Room Joined",
    PlayingCardsUpdated = "Playing Cards Updated",
    CardDeckTypeChanged = "Card Deck Type Changed",
    ModerationStarted = "Moderation Started",
    ModerationStopped = "Moderation Stopped",
    ModerationPlayerKicked = "Player Kicked",
    PlayerRenamed = "Player Renamed",

    //User
    SignUpOpened = "SignUp Opened",
    SignUpStarted = "SignUp Started",
    SignUpCompleted = "SignUp Completed",
    SignInStarted = "SignIn Started",
    SignInCompleted = "SignIn Completed",
    ResetPasswordRequestSent = "Reset Password Request Sent",
    SignOutCompleted = "SignOut Completed",
    RecentRoomVisited = "Recent Room Visited",
    AlignmentTrendVisited = "Alignment Trend Visited",
    PurchaseStarted = "Purchase Started",
    PurchaseCanceled = "Purchase Canceled",
    PurchaseCompleted = "Purchase Completed",
    PurchaseLinkCreated = "Purchase Link Created",
    TrialEnded = "Trial Ended",

    //Player
    PlayerLeftRoom = "Player Left Room",
    PlayerStartedObserving = "Player Started Observing Game",
    PlayerStoppedObserving = "Player Stopped Observing Game",
}

export enum Timing {
    EstimationRoundLength = "Estimation Round Length",
}

export class Tracking {
    analytics?: Analytics;

    public initialize(firebaseAnalytics: Analytics, trackingId: string): void {
        try {
            ReactGA.initialize(trackingId);
            this.analytics = firebaseAnalytics;
        } catch (error) {
            console.warn("Failed to initialize Google Analytics (may be blocked):", error);
        }
    }

    /**
     * category/action are typed as `string` (rather than the `Category`/`Action` enums above)
     * so that other features can define their own self-contained enums — e.g. retro room's
     * `RetroCategory`/`RetroAction` in `features/retro/analytics/RetroTracking.ts` — and send
     * events through this same instance without depending on this file. Existing enum values
     * are string enums, so they satisfy `string` and every call site keeps compiling unchanged.
     */
    public event(category: string, action: string, label?: string): void {
        if (this.analytics) {
            try {
                logEvent(this.analytics, action.toString(), { event_category: category.toString(), event_label: label });
            } catch (error) {
                console.warn("Failed to track event (analytics may be blocked):", error);
            }
        } else {
            // Silently continue - analytics is optional
        }
    }

    public timing(category: string, timing: string, timingMS: number, label?: string): void {
        if (this.analytics) {
            try {
                logEvent(this.analytics, timing.toString(), { timing_category: category.toString(), timing_ms:  timingMS, timing_label: label });
            } catch (error) {
                console.warn("Failed to track timing (analytics may be blocked):", error);
            }
        } else {
            // Silently continue - analytics is optional
        }
    }
}
